import Constant from '@/common/constant/Constant';
import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';
import PropTypes from 'prop-types';

export const DialogConfirmSoftDeleteTicket = props => {
    // Re-render when the translation dictionary loads/updates
    useTranslationSubscription();

    const { isOpen, setIsOpen, detailTicket } = props;

    let messageStatus = trI18n('MSG-CM-CONFIRM-DELETE-CONTENT-ON-TICKET-LIST');

    if (
        detailTicket?.liveOrArchived === Constant.LIVE_OR_ARCHIVED.ARCHIVED
    ) {
        messageStatus = trI18n('MSG-CM-CONFIRM-DELETE-CONTENT');
    }

    const onCloseConfirm = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }
        setIsOpen(false);
    };

    const onSubmitSoftDelete = () => {
        props.submitSoftDelete();
        setIsOpen(false);
    };

    return (
        <Dialog
            open={isOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirmPlease">
                    {messageStatus}
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    variant="contained"
                    className="btn-hg32 btn-handle-delete-user-agree btn-handle-delete-user-agree-important"
                    onClick={onSubmitSoftDelete}
                >
                    {trI18n('CM-BUTTON-OK')}
                </Button>
                <Button
                    variant="contained"
                    className="btn-light btn-hg32"
                    onClick={(event, reason) => onCloseConfirm(event, reason)}
                >
                    {trI18n('CM-BUTTON-CANCEL')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

DialogConfirmSoftDeleteTicket.propTypes = {
    isOpen: PropTypes.any,
    setIsOpen: PropTypes.any,
    detailTicket: PropTypes.any,
};